import {
    STOREFRONT_VALUES_KEYS,
    STOREFRONT_VALUES_NAMESPACES,
} from "@/constants/storefront_values";
import { StorefrontValuesModule } from "@modules/storefront_values/StorefrontValuesModule";
import { singleton } from "tsyringe";

import { GiftRegistryStorefrontValuesSettingsSchema } from "../schemas/GiftRegistryStorefrontValuesSettingsSchema";

@singleton()
class GiftRegistryStorefrontValuesService {
    constructor(
        private readonly storefrontValuesModule: StorefrontValuesModule
    ) {}

    public selectGiftRegistrySettings() {
        return this.storefrontValuesModule.exports.storefrontValuesManager.selectValue(
            {
                namespace: STOREFRONT_VALUES_NAMESPACES.GIFT_REGISTRY_CRITICAL,
                key: STOREFRONT_VALUES_KEYS.GIFT_REGISTRY_SETTINGS,
                schema: GiftRegistryStorefrontValuesSettingsSchema,
            }
        );
    }
}

export default GiftRegistryStorefrontValuesService;
